import React, { useCallback, useContext } from 'react'
import { l } from '@manychat/manyui'

import { EmptyNode } from 'common/builder/components/chart/FlowChart/components/EmptyNode/EmptyNode'
import { NextStep } from 'common/builder/components/chart/FlowChart/components/NextStep/NextStep'
import { NodeContainer } from 'common/builder/components/chart/FlowChart/components/Node/components/NodeContainer/NodeContainer'
import { NodeContentWrapper } from 'common/builder/components/chart/FlowChart/components/Node/components/NodeContentWrapper/NodeContentWrapper'
import { NodeHeader } from 'common/builder/components/chart/FlowChart/components/Node/components/NodeHeader/NodeHeader'
import { NodeComponent } from 'common/builder/components/chart/FlowChart/components/Node/types'
import { NODE_PLACEHOLDER_ID } from 'common/builder/components/chart/FlowChart/constants/index'
import { useFlowChartState } from 'common/builder/components/chart/FlowChart/contexts/FlowChartStateContext'
import { ServicesContext } from 'common/builder/components/chart/FlowChart/contexts/ServiceProvider'
import { GotoConfig } from 'common/builder/components/chart/FlowChart/nodes/shared/config'
import { FlowChartGotoNode } from 'common/builder/components/chart/FlowChart/types/FlowChartNode/FlowChartGotoNode'

import { GotoContent } from './components/GotoContent'

export const Goto: NodeComponent<FlowChartGotoNode> = ({
  node: { id, data },
  container,
  builderId,
}) => {
  const { header, flow, nextStep } = data
  const isEmpty = !flow

  const { isReadonly, isNoInteractions } = useFlowChartState()
  const { gotoService } = useContext(ServicesContext)

  const clearGoto = useCallback(() => {
    gotoService?.clearFlow(id)
  }, [gotoService, id])

  const onOpenFlowClick = useCallback(() => {
    gotoService?.openFlow(flow?.id, flow?.path)
  }, [flow, gotoService])

  const onOpenPickerClick = useCallback(() => {
    gotoService?.addFlow(id)
  }, [gotoService, id])

  return (
    <NodeContainer
      container={container}
      nodeId={id}
      builderId={builderId}
      disableFlowChartInteractions={isNoInteractions}
      width={GotoConfig.width}
      highlightColor={GotoConfig.highlightColor}
    >
      <NodeHeader header={header} />
      <NodeContentWrapper>
        {!isEmpty && (
          <GotoContent
            flowName={flow?.name || ''}
            readonly={isReadonly}
            onClose={clearGoto}
            onFlowOpen={onOpenFlowClick}
          />
        )}

        {isEmpty && (
          <EmptyNode
            id={NODE_PLACEHOLDER_ID}
            text={l.getString(GotoConfig.placeholderText)}
            hoverBackground={GotoConfig.placeholderBackground}
            hoverBorderColor={GotoConfig.placeholderBorderColor}
            onClick={onOpenPickerClick}
          />
        )}
      </NodeContentWrapper>
      {nextStep && <NextStep key={nextStep.id} nextStep={nextStep} />}
    </NodeContainer>
  )
}
